// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.insurance-select_container-Exw1d {
  width: 260px;
}

.insurance-select_input-wHm_8 {
  padding: 0px 8px 0px 12px;
}

.insurance-select_popup-z5ol1 {
  max-height: 300px;
  overflow: auto;
}

.insurance-circularProgress-nEUDH {
  display: block;
  margin: 12px auto;
  color: var(--accent-color);
}

.insurance-circularProgress-nEUDH .rmwc-circular-progress__path {
  stroke-width: 3px;
}

.insurance-selectError-Zomif {
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-neutral-500);
  font-size: 15px;
  cursor: default;
}

.insurance-planItem-kRcFu {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 0px 8px 0px 0px;
}

.insurance-planPrice-bBW_k {
  color: var(--money-color);
  font-weight: 500;
  font-size: 14px;
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/insurance/insurance.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB","sourcesContent":[".select_container {\n  width: 260px;\n}\n\n.select_input {\n  padding: 0px 8px 0px 12px;\n}\n\n.select_popup {\n  max-height: 300px;\n  overflow: auto;\n}\n\n.circularProgress {\n  display: block;\n  margin: 12px auto;\n  color: var(--accent-color);\n}\n\n.circularProgress :global(.rmwc-circular-progress__path) {\n  stroke-width: 3px;\n}\n\n.selectError {\n  padding: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--color-neutral-500);\n  font-size: 15px;\n  cursor: default;\n}\n\n.planItem {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  padding: 0px 8px 0px 0px;\n}\n\n.planPrice {\n  color: var(--money-color);\n  font-weight: 500;\n  font-size: 14px;\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"select_container": `insurance-select_container-Exw1d`,
	"select_input": `insurance-select_input-wHm_8`,
	"select_popup": `insurance-select_popup-z5ol1`,
	"circularProgress": `insurance-circularProgress-nEUDH`,
	"selectError": `insurance-selectError-Zomif`,
	"planItem": `insurance-planItem-kRcFu`,
	"planPrice": `insurance-planPrice-bBW_k`
};
export default ___CSS_LOADER_EXPORT___;
